import React from "react";
import { TextAreaProps } from "react-html-props";

const RichTextEditorMock = ({ error, onChange, ...props }: Props) => (
  <textarea {...props} onChange={(e) => onChange(e.target.value)} />
);

export default RichTextEditorMock;

interface Props extends Omit<TextAreaProps, "onChange"> {
  error?: boolean;
  onChange: (value: string) => void;
}
